import { featureContainer } from '@payfit/growth-platform-brand-system-v2';
import { useScreenSize } from 'libs/growth-platform-brand-system-v2/src/utils/utils';
import React, { lazy } from 'react';

const AccordionLinkComponent = lazy(
  () => import('../BlockComponents/AccordionLinkComponent'),
);
const AnchorButtonsListComponent = lazy(
  () => import('../BlockComponents/AnchorButtonsListComponent'),
);
const AskADemoLinkComponent = lazy(
  () => import('../BlockComponents/AskADemoLinkComponent'),
);
const BasicTableComponent = lazy(
  () => import('../BlockComponents/BasicTableComponent'),
);
const BenefitsSectionComponent = lazy(
  () => import('../BlockComponents/BenefitsSectionComponent'),
);
const CalloutV2Component = lazy(
  () => import('../BlockComponents/CalloutV2Component'),
);
const CardsGridComponent = lazy(
  () => import('../BlockComponents/CardsGridComponent'),
);
const CardsListComponent = lazy(
  () => import('../BlockComponents/CardsListComponent'),
);
const ConditionalBlockComponent = lazy(
  () => import('../BlockComponents/ConditionalBlockComponent'),
);
const ContentComponent = lazy(
  () => import('../BlockComponents/ContentComponent'),
);
const ContentWithItemsListComponent = lazy(
  () => import('../BlockComponents/ContentWithItemsListComponent'),
);
const ConversionBannerComponent = lazy(
  () => import('../BlockComponents/ConversionBannerComponent'),
);
const EmbedArcadeComponent = lazy(
  () => import('../BlockComponents/EmbedArcadeComponent'),
);
const FaqComponent = lazy(() => import('../BlockComponents/FaqComponent'));
const FeaturesListComponent = lazy(
  () => import('../BlockComponents/FeaturesListComponent'),
);
const FullResultsCalculatorComponent = lazy(
  () => import('../BlockComponents/FullResultsCalculatorComponent'),
);
const HeroComponent = lazy(() => import('../BlockComponents/HeroComponent'));
const HeroHomeComponent = lazy(
  () => import('../BlockComponents/HeroHomeComponent'),
);
const HeroThankYouComponent = lazy(
  () => import('../BlockComponents/HeroThankYouComponent'),
);
const HeroVideoComponent = lazy(
  () => import('../BlockComponents/HeroVideoComponent'),
);
const HowItWorkCarouselComponent = lazy(
  () => import('../BlockComponents/HowItWorkCarouselComponent'),
);
const ImageBlockComponent = lazy(
  () => import('../BlockComponents/ImageBlockComponent'),
);
const ImageTabComponent = lazy(
  () => import('../BlockComponents/ImageTabComponent'),
);
const IntegrationsComponent = lazy(
  () => import('../BlockComponents/IntegrationsComponent'),
);
const JobExplorerComponent = lazy(
  () => import('../BlockComponents/JobExplorerComponent'),
);
const KeyFigureComponent = lazy(
  () => import('../BlockComponents/KeyFigureComponent'),
);
const KeyFiguresV2Component = lazy(
  () => import('../BlockComponents/KeyFiguresV2Component'),
);
const LogoListStaticComponent = lazy(
  () => import('../BlockComponents/LogoListStaticComponent'),
);
const LogosListComponent = lazy(
  () => import('../BlockComponents/LogosListComponent'),
);
const NavigationButtonsListComponent = lazy(
  () => import('../BlockComponents/NavigationButtonsListComponent'),
);
const NewFeaturesListComponent = lazy(
  () => import('../BlockComponents/NewFeaturesListComponent'),
);
const QuoteComponent = lazy(() => import('../BlockComponents/QuoteComponent'));
const ResultsCalculatorComponent = lazy(
  () => import('../BlockComponents/ResultsCalculatorComponent'),
);
const SalaryCalculatorComponent = lazy(
  () => import('../BlockComponents/SalaryCalculatorComponent'),
);
const SeparatorComponent = lazy(
  () => import('../BlockComponents/SeparatorComponent'),
);
const SimpleCardsCarouselComponent = lazy(
  () => import('../BlockComponents/SimpleCardsCarouselComponent'),
);
const TableComparisonComponent = lazy(
  () => import('../BlockComponents/TableComparisonComponent'),
);
const TablePriceBlockComponent = lazy(
  () => import('../BlockComponents/TablePriceBlockComponent'),
);
const TabsV2Component = lazy(
  () => import('../BlockComponents/TabsV2Component'),
);
const TabsValuePropositionComponent = lazy(
  () => import('../BlockComponents/TabsValuePropositionComponent'),
);
const TestimonialCarousselAutoScrollingComponent = lazy(
  () => import('../BlockComponents/TestimonialCarousselAutoScrollingComponent'),
);
const TestimonialComponent = lazy(
  () => import('../BlockComponents/TestimonialComponent'),
);
const TestimonialSectionLoop = lazy(
  () => import('../BlockComponents/TestimonialSectionLoopComponent'),
);
const TestimonialSliderComponent = lazy(
  () => import('../BlockComponents/TestimonialSliderComponent'),
);
const TestimonialStaticComponent = lazy(
  () => import('../BlockComponents/TestimonialStaticComponent'),
);
const TextBlockComponent = lazy(
  () => import('../BlockComponents/TextBlockComponent'),
);
const TextInterviewComponent = lazy(
  () => import('../BlockComponents/TextInterviewComponent'),
);
const TextSectionComponent = lazy(
  () => import('../BlockComponents/TextSectionComponent'),
);
const TitleAndParagraphTabComponent = lazy(
  () => import('../BlockComponents/TitleAndParagraphTabComponent'),
);
const ValuePropositionComponent = lazy(
  () => import('../BlockComponents/ValuePropositionComponent'),
);
const ValuePropositionMinimalComponent = lazy(
  () => import('../BlockComponents/ValuePropositionMinimalComponent'),
);
const VersusComponent = lazy(
  () => import('../BlockComponents/VersusComponent'),
);
const VideoModuleComponent = lazy(
  () => import('../BlockComponents/VideoModuleComponent'),
);

const HubspotFormComponent = lazy(
  () => import('../BlockComponents/HubspotFormComponent'),
);

const PricingInfoSectionBlockComponent = lazy(
  () => import('../BlockComponents/PricingInfoSectionBlock'),
);

export const BlocksType = ({
  id,
  pageId,
  block,
  locale,
  heroData,
  index,
  doc,
  options,
}: any) => {
  const screenSize = useScreenSize();
  const { __typename, ..._block } = block;
  const sectionId = `${index + 1}_${__typename}`;
  const defaultProps = {
    block: _block,
    sectionId,
    locale,
    id,
    pageId,
    heroData,
    index,
    doc,
    options,
  };

  if (block.__typename === 'DatoCmsAccordionLink')
    return <AccordionLinkComponent {...defaultProps} />;

  if (__typename === 'DatoCmsAnchorButtonsList')
    return <AnchorButtonsListComponent {...defaultProps} />;

  if (block.__typename === 'DatoCmsAskADemoLink')
    return <AskADemoLinkComponent {...defaultProps} />;

  if (__typename === 'DatoCmsBasicTable')
    return <BasicTableComponent {...defaultProps} />;

  if (__typename === 'DatoCmsBenefitsSection')
    return <BenefitsSectionComponent {...defaultProps} />;

  if (__typename === 'DatoCmsCardsList')
    return <CardsListComponent {...defaultProps} />;

  if (__typename === 'DatoCmsConditionalBlock')
    return <ConditionalBlockComponent {...defaultProps} />;

  if (__typename === 'DatoCmsCardsGrid') {
    return (
      <CardsGridComponent {...defaultProps} id={defaultProps?.block?.anchor} />
    );
  }

  if (__typename === 'DatoCmsContent')
    return <ContentComponent {...defaultProps} />;

  if (__typename === 'DatoCmsContentWithItemsList') {
    return (
      <ContentWithItemsListComponent
        {...defaultProps}
        id={defaultProps?.block?.anchor}
      />
    );
  }

  if (__typename === 'DatoCmsConversionBanner')
    return (
      <ConversionBannerComponent
        {...defaultProps}
        id={defaultProps?.block?.anchor}
      />
    );

  if (block.__typename === 'DatoCmsEmbedArcade') {
    return <EmbedArcadeComponent key={index} block={block} />;
  }

  if (__typename === 'DatoCmsFaq') return <FaqComponent {...defaultProps} />;

  if (__typename === 'DatoCmsFeaturesList')
    return <FeaturesListComponent {...defaultProps} />;

  if (
    __typename === 'DatoCmsFilterNewFeaturesWall' &&
    doc?.allDatoCmsNewFeaturePage
  )
    return (
      <NewFeaturesListComponent
        {...defaultProps}
        allDatoCmsNewFeaturePage={doc.allDatoCmsNewFeaturePage}
      />
    );

  if (__typename === 'DatoCmsFullResultsCalculator')
    return <FullResultsCalculatorComponent {...defaultProps} />;

  if (block.__typename === 'DatoCmsHero')
    return <HeroComponent {...defaultProps} />;

  if (block.__typename === 'DatoCmsHeroHome')
    return <HeroHomeComponent {...defaultProps} />;

  if (__typename === 'DatoCmsHeroThankYou') {
    return <HeroThankYouComponent {...defaultProps} />;
  }

  if (__typename === 'DatoCmsHeroVideo') {
    return <HeroVideoComponent {...defaultProps} />;
  }

  if (__typename === 'DatoCmsHowItWork')
    return <HowItWorkCarouselComponent {...defaultProps} />;

  if (block.__typename === 'DatoCmsImageBlock')
    return <ImageBlockComponent {...defaultProps} />;

  if (__typename === 'DatoCmsImageTab')
    return <ImageTabComponent {...defaultProps} />;

  if (__typename === 'DatoCmsIntegration')
    return <IntegrationsComponent {...defaultProps} />;

  if (__typename === 'DatoCmsJobExplorer')
    return <JobExplorerComponent {...defaultProps} />;

  if (__typename === 'DatoCmsKeyFigure')
    return <KeyFigureComponent {...defaultProps} />;

  if (__typename === 'DatoCmsKeyFiguresV2') {
    return (
      <KeyFiguresV2Component
        {...defaultProps}
        id={defaultProps?.block?.anchor}
      />
    );
  }

  if (__typename === 'DatoCmsLogoList')
    return <LogosListComponent {...defaultProps} />;

  if (__typename === 'DatoCmsLogoListStatic')
    return <LogoListStaticComponent {...defaultProps} />;

  if (__typename === 'DatoCmsNavigationButtonsList')
    return <NavigationButtonsListComponent {...defaultProps} />;

  if (__typename === 'DatoCmsQuote')
    return <QuoteComponent {...defaultProps} />;

  if (__typename === 'DatoCmsResultsCalculator')
    return <ResultsCalculatorComponent {...defaultProps} />;

  if (__typename === 'DatoCmsSalaryCalculator')
    return <SalaryCalculatorComponent {...defaultProps} />;

  if (block.__typename === 'DatoCmsSeparator')
    return <SeparatorComponent {...defaultProps} />;

  if (__typename === 'DatoCmsSimpleCardsCarousel') {
    return (
      <SimpleCardsCarouselComponent
        {...defaultProps}
        pageId={pageId}
        id={defaultProps?.block?.anchor}
      />
    );
  }

  if (__typename === 'DatoCmsTabsV2') {
    return <TabsV2Component {...defaultProps} />;
  }

  if (block.__typename === 'DatoCmsTablePriceBlock') {
    return <TablePriceBlockComponent {...defaultProps} />;
  }

  if (__typename === 'DatoCmsComparisonTable')
    return (
      <TableComparisonComponent
        {...defaultProps}
        doc={doc}
        openTablePrice={options?.openTablePrice}
        setOpenTablePrice={options?.setOpenTablePrice}
      />
    );

  if (__typename === 'DatoCmsTabsValueProposition') {
    return <TabsValuePropositionComponent {...defaultProps} />;
  }

  if (block.__typename === 'DatoCmsTestimonial' && !block?.isLoop) {
    return <TestimonialComponent {...defaultProps} screenSize={screenSize} />;
  }

  if (block.__typename === 'DatoCmsTestimonial' && block?.isLoop) {
    return <TestimonialSectionLoop {...defaultProps} />;
  }

  if (__typename === 'DatoCmsTestimonialCarousselAutoScrolling')
    return <TestimonialCarousselAutoScrollingComponent {...defaultProps} />;

  if (__typename === 'DatoCmsTestimonialSlider') {
    return (
      <TestimonialSliderComponent
        {...defaultProps}
        id={defaultProps?.block?.anchor}
      />
    );
  }

  if (__typename === 'DatoCmsTestimonialStatic')
    return <TestimonialStaticComponent {...defaultProps} />;

  if (__typename === 'DatoCmsTextBlock')
    return <TextBlockComponent {...defaultProps} />;

  if (__typename === 'DatoCmsTextInterview')
    return <TextInterviewComponent {...defaultProps} />;

  if (__typename === 'DatoCmsTextSection')
    return <TextSectionComponent {...defaultProps} />;

  if (block.__typename === 'DatoCmsTitleAndParagraphTab')
    return <TitleAndParagraphTabComponent {...defaultProps} />;

  if (block.__typename === 'DatoCmsValueProposition')
    return <ValuePropositionComponent {...defaultProps} />;

  if (block.__typename === 'DatoCmsValuePropositionMinimal')
    return (
      <ValuePropositionMinimalComponent
        {...defaultProps}
        id={defaultProps?.block?.anchor}
      />
    );

  if (__typename === 'DatoCmsVersusSection')
    return <VersusComponent {...defaultProps} />;

  if (__typename === 'DatoCmsVideoModule') {
    return <VideoModuleComponent {...defaultProps} />;
  }
  if (block.__typename === 'DatoCmsCalloutV2') {
    return <CalloutV2Component {...defaultProps} className={featureContainer} />
  }
  if (__typename === 'DatoCmsHubspotForm') {
    return <HubspotFormComponent {...defaultProps} />;
  }
  if (__typename === 'DatoCmsPricingInfoSection') {
    return <PricingInfoSectionBlockComponent {...defaultProps} />;
  }
};
